import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import _cloneDeep from 'lodash/cloneDeep';
import MenuItem from '@mui/material/MenuItem';
import { comparisonParams, filterParams } from '../../../utils/segments';
import { addQueryParams } from '../../../utils/browser';
import ReduxStore from 'src/types/store/reduxStore';
import _pick from 'lodash/pick';

const mapStateToProps = (state: ReduxStore) =>
  _pick(state, ['app', 'subCategories', 'categories', 'entityService', 'retailer', 'mainTimePeriod']);

type Props = ReturnType<typeof mapStateToProps> &
  RouteComponentProps & {
    searchText: string;
    togglePanel?: () => {};
  };

class SubCategories extends React.Component<Props> {
  public state: {
    subCategories: any[];
  } = { subCategories: [] };

  componentWillMount() {
    const { subCategories } = this.props;
    const allSubCategories = _cloneDeep(subCategories);
    allSubCategories.sort(
      (a, b) =>
        (b as any).relevancyScore - (a as any).relevancyScore ||
        (a as any).subCategoryName.localeCompare((b as any).subCategoryName)
    );
    this.setState({ subCategories: allSubCategories });
  }

  componentWillReceiveProps(nextProps) {
    const { searchText, subCategories } = nextProps;

    const subCategoriesFiltered = subCategories.filter(
      (val) => val.subCategoryName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
    this.setState({
      subCategories: subCategoriesFiltered
    });
  }

  handleTouchTap = (selection) => {
    const { togglePanel, location, retailer, mainTimePeriod } = this.props;
    const entity = {
      id: selection.subCategoryId,
      type: 'subcategory'
    };

    const existingParams = addQueryParams(location, retailer, mainTimePeriod, [...filterParams, ...comparisonParams]);

    togglePanel();
    this.props.history.push(`?ctype=${entity.type}&cid=${entity.id}&${existingParams}`);
  };

  showNoSubCategories() {
    const { subCategories } = this.state;

    if (subCategories.length > 0) {
      return null;
    }

    return <div style={{ padding: '10px' }}>No subcategories found.</div>;
  }

  render() {
    const { subCategories } = this.state;
    return (
      <div style={{ padding: '10px' }}>
        {subCategories.map((val) => (
          <MenuItem key={val.subCategoryId} style={{ fontSize: '14px' }} onClick={() => this.handleTouchTap(val)}>
            {val.subCategoryName}
          </MenuItem>
        ))}
        {this.showNoSubCategories()}
      </div>
    );
  }
}

export default withRouter(connect((state) => state)(SubCategories));
